import React, { useState, useCallback, useMemo, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { getExpandedMenuState } from './routeCalculation';
import MenuChild from './MenuChild';
import Link from "../../../Link";
import { Menu as MenuProps } from "../../../../interfaces/common";
import { AuthContext } from '../../../../contexts/AuthContext';
import { hasResourseAccess } from "../../../../utils/methods";

const Menu: React.FC<MenuProps> = ({
  id, icon, text, childrens, redirectsTo, sidebarExpanded
}) => {
  const navigate = useNavigate();
  const { permissions, isSystemAdmin } = useContext(AuthContext);

  const currentRoute = window.location.pathname;
  const selected = getExpandedMenuState(id, currentRoute);

  const [expanded, setExpanded] = useState<boolean>(selected);

  const handleExpandCollapse = useCallback(() => {
    setExpanded((prev) => !prev);
  }, [setExpanded]);

  const filteredChildrens = useMemo(() => {
    return (childrens || []).filter((tempChild) => {
      return hasResourseAccess(isSystemAdmin, permissions, tempChild.accessibleTo ? tempChild : null);
    });
  }, [childrens, permissions]);

  const handleMenuClick = useCallback(() => {
    redirectsTo && navigate(redirectsTo);
  }, [navigate]);

  const handleMenuItemClick = useCallback(() => {
    if (filteredChildrens && filteredChildrens.length > 0) {
      handleExpandCollapse();
    } else {
      handleMenuClick();
    }
  }, [id, filteredChildrens]);

  return (
    <li className={`menu-item ${(expanded ? (filteredChildrens && filteredChildrens.length > 0 ? "open active" : "active") : "")}`}>
      <Link
        className={`menu-link waves-effect ${filteredChildrens && filteredChildrens.length > 0 ? 'menu-toggle' : ''}`}
        href={redirectsTo || '#'}
        onClick={handleMenuItemClick}
        icon={icon}
        text={sidebarExpanded ? text : ''}
      />
      {expanded && filteredChildrens && filteredChildrens.length > 0 && sidebarExpanded && (
        <ul className="menu-sub" style={{ display: "block" }}>
          {
            filteredChildrens.map((child) => (
              <MenuChild key={child.text} {...child} />
            ))
          }
        </ul>
      )}
    </li>
  );
};

export default Menu;
